import { Model } from '../model';

export class Guide extends Model {
    public id: number;
    public name: Object;
    public content: Object;    
}
